import {Component, effect, inject, OnDestroy, TemplateRef, viewChild, ViewContainerRef} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LoadingService} from '@core/services/loading.service';
import {Overlay, OverlayModule, OverlayRef} from '@angular/cdk/overlay';
import {TemplatePortal} from '@angular/cdk/portal';

@Component({
  selector: 'app-spinner-overlay',
  standalone: true,
  imports: [MatProgressSpinnerModule, OverlayModule],
  template: `
    <ng-template #spinnerRef>
      <div class="global-spinner-container">
        <mat-spinner mode="indeterminate" diameter="50"></mat-spinner>
      </div>
    </ng-template>
  `,
  styles: [`
    .global-spinner-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
    }
  `]
})
export class SpinnerOverlay implements OnDestroy {
  private loadingService = inject(LoadingService);
  private overlay = inject(Overlay);
  private viewContainerRef = inject(ViewContainerRef);

  private spinnerTemplate = viewChild.required<TemplateRef<any>>('spinnerRef');
  private overlayRef: OverlayRef | null = null;

  constructor() {
    // Escuchamos la señal del servicio
    effect(() => {
      if (this.loadingService.isLoading()) {
        this.show();
      } else {
        this.hide();
      }
    });
  }

  ngOnDestroy() {
    this.overlayRef?.dispose();
  }

  private show() {
    // Si ya está visible, no hacemos nada
    if (this.overlayRef?.hasAttached()) return;

    // Creamos el overlay si no existe
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'custom-spinner-backdrop', // Clase definida en styles.scss
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
        scrollStrategy: this.overlay.scrollStrategies.block() // Bloquea el scroll
      });
    }

    // Adjuntamos el template al overlay
    const portal = new TemplatePortal(this.spinnerTemplate(), this.viewContainerRef);
    this.overlayRef.attach(portal);
  }

  private hide() {
    if (this.overlayRef?.hasAttached()) {
      this.overlayRef.detach();
    }
  }
}
